import React, { Component } from "react";
import styles from "./routeTripsContent.module.scss";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { withRoutes } from "../../../shared/containers/containerRoutes";

class RouteTripsCreateTool extends Component {
  onCreateHandle() {
    const { route, dayOff, onCreateTrip } = this.props;

    const options = {
      routeId: route.id,
      dayOff: dayOff,
    };
    onCreateTrip(options);
  }

  render() {
    const { route } = this.props;

    return (
      <div className={styles.routeTripsToolsContainer}>
        {route.controlPoints.length > 0 ? (
          <div>
            <ButtonPrimary handleClick={this.onCreateHandle.bind(this)} title="Создать новый рейс" />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRoutes(RouteTripsCreateTool);
